import { Section } from 'components'
import React from 'react'

const TempFeatures = () => {
  return (
    <Section padding="p-0">
      <hr />
    </Section>
  )
}

export default TempFeatures
